import { render, staticRenderFns } from "./veStuCheckTypeShow.vue?vue&type=template&id=46ff7d24&scoped=true"
import script from "./veStuCheckTypeShow.vue?vue&type=script&lang=js"
export * from "./veStuCheckTypeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff7d24",
  null
  
)

export default component.exports